// Base URL for images from the API
const BASE_URL = 'https://maroon-grouse-638711.hostingersite.com';

/**
 * Get full image URL by adding base URL if the path is relative
 * @param url - The image URL (can be relative or absolute)
 * @returns Full image URL
 */
export function getFullImageUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  
  // Already a full URL
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Data URL (base64)
  if (url.startsWith('data:')) {
    return url;
  }
  
  // Relative path - add base URL
  return `${BASE_URL}/${url}`;
}

/**
 * Add cache busting to image URL
 * @param url - The image URL
 * @returns URL with cache busting timestamp
 */
export function addCacheBusting(url: string | null | undefined): string | null {
  if (!url) return null;
  
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}t=${Date.now()}`;
}

/**
 * Get full image URL with cache busting
 * @param url - The image URL
 * @returns Full image URL with cache busting
 */
export function getImageUrl(url: string | null | undefined): string | null {
  const fullUrl = getFullImageUrl(url);
  return addCacheBusting(fullUrl);
}
